import React, { useState, useEffect } from "react";
import axios from "axios";
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import DynamicForm from './DynamicForm';
import LoaderComponent from "../../../libraries/loader/loader";
import { Fetchexecutequery, Fetchheaderdata, Fetchupdatequery } from '../../../services/process/BRS1/brsService7';
import { CreateData } from '../../../services/process/process_data/process_data';
import { Icon } from 'semantic-ui-react';
import './reconSummary.css';
import Select from "react-select";

function PurchaseRequirement() {
  const [formData, setFormData] = useState({});
  const [userCredentials] = useState(JSON.parse(sessionStorage.getItem("userCredentials")));
  const [formData1, setFormData1] = useState({});
  const [formData2, setFormData2] = useState({});
  const [formData3, setFormData3] = useState({});
  const [rowData, setRowData] = useState([]);
  const [fields, setFields] = useState(null);
  const [columnDefs, setColumnDefs] = useState([]);
  const [fields1, setFields1] = useState(null);
  const [columnDefs1, setColumnDefs1] = useState([]);
  const [fields2, setFields2] = useState(null);
  const [columnDefs2, setColumnDefs2] = useState([]);
  const [fields3, setFields3] = useState(null);
  const [columnDefs3, setColumnDefs3] = useState([]);
  const [prfno, setPrfno] = useState('');
  const [manager, setManager] = useState('');
  const [section2Rows, setSection2Rows] = useState([{}]);
  const [section3Rows, setSection3Rows] = useState([{}]);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [editMode, setEditMode] = useState(false); // State to track if in edit mode
  const [quotations, setQuotations] = useState([{ id: 1, label: "Quotation 1" }]);
  const [selectedQuotationId, setSelectedQuotation] = useState(null);
  const [quotationData, setQuotationData] = useState({});
  const [quotationinputData, setQuotationinputData] = useState([]);

  // State to control collapsibility of divs
  const [isDiv1Open, setIsDiv1Open] = useState(true);
  const [isDiv2Open, setIsDiv2Open] = useState(true);
  const [isDiv3Open, setIsDiv3Open] = useState(true);
  const [isDiv4Open, setIsDiv4Open] = useState(true);

  useEffect(() => {
    fetchFieldInfo2();
    fetchFieldInfo1();
    fetchFieldInfo3();
    fetchFieldInfo4();
    Fetchprfinfo();
    Fetchmanagerinfo();
    console.log(userCredentials)
  }, []);

useEffect(() => {
  if (selectedQuotationId !== null) {
    // Set formData2 with the data of the selected quotation from quotationData
    console.log("selectedQuotationId",selectedQuotationId,quotationData[selectedQuotationId])
    setFormData2(quotationData[selectedQuotationId] || {});
  }
}, [selectedQuotationId]);

useEffect(() => {
  if (selectedQuotationId !== null) {
    // Set formData2 with the data of the selected quotation from quotationData
    console.log("selectedQuotationId",selectedQuotationId,quotationData[selectedQuotationId])
    setSection3Rows(quotationinputData[selectedQuotationId] || [{}]);
  }
}, [selectedQuotationId]);


  const addRowInSection3 = () => {
    setSection3Rows(prevRows => [...prevRows, {}]);
  };
  
  const addRowInSection2 = () => {
     setSection2Rows([...section2Rows, {}]);  // Adds an empty object as a new row
  };


  const formatColumnName = (name) =>
    name.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());

  const fetchFieldInfo1 = async () => {
    const payload = { headerconfig_id: 2 };

    try {
      const FileUploadCredentials = Fetchheaderdata();
      const response = await axios.post(
        FileUploadCredentials[1], // URL
        payload,                  // Payload
        FileUploadCredentials[0]   // Headers or Credentials
      );

      const data = response.data;
      if (data.fields && data.fields.length > 0) {
        const columns = data.fields.map((field) => ({
          headerName: formatColumnName(field.columnName),
          field: field.columnName,
        }));
        columns.push({
          headerName: "Edit",
          field: "edit",
          cellRendererFramework: (params) => (
            <Icon
              name="edit"
              style={{ cursor: 'pointer' }}
              onClick={() => handleEditClick(params.data)}
            />
          ),
          width: 100, // Set width for the edit column
        });

        setColumnDefs(columns);
        setFields(data.fields);
      }
    } catch (error) {
      console.error("Error fetching field info:", error);
      setError("Error fetching fields data");
    }
    setLoading(false);
  };

  const handleEditClick = (row) => {
    console.log("Editing row:", row);
    setFormData(row); // Populate formData with row data for editing
    setEditMode(true); // Set edit mode to true
  };

  const fetchFieldInfo2 = async () => {
    const payload = { headerconfig_id: 3 };

    try {
      const FileUploadCredentials = Fetchheaderdata();
      const response = await axios.post(
        FileUploadCredentials[1], // URL
        payload,                  // Payload
        FileUploadCredentials[0]   // Headers or Credentials
      );

      const data = response.data;
      console.log(data)
      if (data.fields && data.fields.length > 0) {
        const columns = data.fields.map((field) => ({
          headerName: formatColumnName(field.columnName),
          field: field.columnName,
        }));
        columns.push({
          headerName: "Edit",
          field: "edit",
          cellRendererFramework: (params) => (
            <Icon
              name="edit"
              style={{ cursor: 'pointer' }}
              onClick={() => handleEditClick(params.data)}
            />
          ),
          width: 100, // Set width for the edit column
        });

        setColumnDefs1(columns);
        setFields1(data.fields);
      }
    } catch (error) {
      console.error("Error fetching field info:", error);
      setError("Error fetching fields data");
    }
    setLoading(false);
  };

  const fetchFieldInfo3 = async () => {
    const payload = { headerconfig_id: 4 };

    try {
      const FileUploadCredentials = Fetchheaderdata();
      const response = await axios.post(
        FileUploadCredentials[1], // URL
        payload,                  // Payload
        FileUploadCredentials[0]   // Headers or Credentials
      );

      const data = response.data;
      console.log(data)
      if (data.fields && data.fields.length > 0) {
        const columns = data.fields.map((field) => ({
          headerName: formatColumnName(field.columnName),
          field: field.columnName,
        }));
        columns.push({
          headerName: "Edit",
          field: "edit",
          cellRendererFramework: (params) => (
            <Icon
              name="edit"
              style={{ cursor: 'pointer' }}
              onClick={() => handleEditClick(params.data)}
            />
          ),
          width: 100, // Set width for the edit column
        });

        setColumnDefs2(columns);
        setFields2(data.fields);
      }
    } catch (error) {
      console.error("Error fetching field info:", error);
      setError("Error fetching fields data");
    }
    setLoading(false);
  };

  const fetchFieldInfo4 = async () => {
    const payload = { headerconfig_id: 6 };

    try {
      const FileUploadCredentials = Fetchheaderdata();
      const response = await axios.post(
        FileUploadCredentials[1], // URL
        payload,                  // Payload
        FileUploadCredentials[0]   // Headers or Credentials
      );

      const data = response.data;
      console.log(data)
      if (data.fields && data.fields.length > 0) {
        const columns = data.fields.map((field) => ({
          headerName: formatColumnName(field.columnName),
          field: field.columnName,
        }));
        columns.push({
          headerName: "Edit",
          field: "edit",
          cellRendererFramework: (params) => (
            <Icon
              name="edit"
              style={{ cursor: 'pointer' }}
              onClick={() => handleEditClick(params.data)}
            />
          ),
          width: 100, // Set width for the edit column
        });

        setColumnDefs3(columns);
        setFields3(data.fields);
      }
    } catch (error) {
      console.error("Error fetching field info:", error);
      setError("Error fetching fields data");
    }
    setLoading(false);
  };


  const Fetchprfinfo = () => {
    let payload = {

      query:`select expression,value from pouat.unique_number where id=1;`

    }
    console.log('payload---', payload)

    var FileUploadCredentials = Fetchexecutequery();
    console.log('FileUploadCredentials---',FileUploadCredentials[0])

    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
      .then(
        response => {
          console.log("Validate Credentials Response!!!", response);
          let data = response["data"];
          const userPrefix = userCredentials["user_name"].substring(0, 2).toUpperCase();
          const combinedString = `${data[0].expression}${data[0].value}${userPrefix}`;
          console.log("prfdata",combinedString)
          setPrfno(combinedString);
          // const dropdownOptions = data.map(item => ({
             //  value: item.Database, // The value for the dropdown option
             //  label: item.Database  // The label for the dropdown option
         //  }));
         //  console.log(dropdownOptions);
        }
      )
      .catch((error) => {
        console.error("Error in database request:", error);
      });
  }

  const Fetchmanagerinfo = () => {
    let payload = {

      query:`select reporting_manager from pouat.reporting_manager where user_id=${userCredentials["user_id"]};`

    }
    console.log('payload---', payload)

    var FileUploadCredentials = Fetchexecutequery();
    console.log('FileUploadCredentials---',FileUploadCredentials[0])

    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
      .then(
        response => {
          console.log("Validate Credentials Response!!!", response);
          let data = response["data"];
          const manager = data[0]["reporting_manager"].toUpperCase();
          setManager(manager );
        }
      )
      .catch((error) => {
        console.error("Error in database request:", error);
      });
  }


  
  const deleteRowInSection2 = (index) => {
  if (section2Rows.length > 1) {
    const updatedRows = section2Rows.filter((_, rowIndex) => rowIndex !== index);
    setSection2Rows(updatedRows);
  }
};

  const deleteRowInSection3 = (index) => {
  if (section3Rows.length > 1) {
    const updatedRows = section3Rows.filter((_, rowIndex) => rowIndex !== index);
    setSection3Rows(updatedRows);
  }
};


  const handleCreate = () => {
    const payload = {
      database: 'pouat',
      table: 'purchase_requirement',
      formData
    };

    const FileUploadCredentials = CreateData();

    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
      .then(response => {
        console.log("Create response:", response);
        window.location.reload();
      })
      .catch((error) => {
        console.error("Error creating data:", error);
        setError("Error creating data");
      });
  };

  const getFormattedDate = () => {
    const currentDate = new Date();
    return currentDate.toISOString().slice(0, 19).replace("T", " ");
  };

  const handleUpdate = () => {
    const formattedDate = getFormattedDate();
    const updatedFormData = [formData,{'is_dept_head_approved' : 0},{'modified_by': userCredentials.user_id},{'modified_date': formattedDate},{'po_status': 'SENT TO DEPARTMENT HEAD'}];

    // Remove primary_id from the copied formData
    delete updatedFormData.primary_id;
    const payload = {
      schema_name: 'pouat',
      table: 'departments',
      set_column : updatedFormData,
      'where' : [{"primary_id":formData.primary_id}]
    };

    const FileUploadCredentials = Fetchupdatequery();

    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
      .then(response => {
        console.log("Update response:", response);
        setEditMode(false); // Reset edit mode after updating
        window.location.reload();
      })
      .catch((error) => {
        console.error("Error updating data:", error);
        setError("Error updating data");
      });
  };



  const addQuotation1 = () => {
    setQuotations((prevQuotations) => [
      ...prevQuotations,
      { id: prevQuotations.length + 1, label: `Quotation ${prevQuotations.length + 1}` }
    ]);
    setFormData2({});
    setSection3Rows([{}]);
  };

const addQuotation = () => {
  setQuotations((prevQuotations) => {
    const newId = prevQuotations.length; // Get the next id
    const newId1 = prevQuotations.length +1; // Get the next id

    const newQuotations = [
      ...prevQuotations,
      { id: newId1, label: `Quotation ${newId1}` }
    ];
    setSelectedQuotation(newId); // Set the new quotation as selected
    setFormData2({}); // Reset form data for the new quotation
    setSection3Rows([{}]); // Reset section rows

    return newQuotations;
  });
};



  const handleInputChange = (name, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleInputChange3_1 = (name, value, index) => {
  setSection3Rows(prevRows => {
    const updatedRows = [...prevRows];
    updatedRows[index] = {
      ...updatedRows[index],
      [name]: value,
    };
    return updatedRows;
  });
};

  const handleInputChange1 = (name, value, index) => {
   setSection2Rows(prevRows => {
    const updatedRows = [...prevRows];
    updatedRows[index] = {
      ...updatedRows[index],
      [name]: value,
      };
     return updatedRows;
    });
  };

  const handlequotatationInputChange3 = (name, value, index) => {
   setSection3Rows(prevRows => {
    const updatedRows = [...prevRows];
    updatedRows[index] = {
      ...updatedRows[index],
      [name]: value,
      };
     return updatedRows;
    });

   setQuotationinputData(prevQuotationData => {
    const updatedQuotationData = [...prevQuotationData];
    if (!updatedQuotationData[selectedQuotationId]) {
      // Initialize section3Rows for the selectedQuotationId if it doesn't exist
      updatedQuotationData[selectedQuotationId] = [];
    }

    // Ensure the row exists in quotationdata for the current index
    if (!updatedQuotationData[selectedQuotationId][index]) {
      updatedQuotationData[selectedQuotationId][index] = {};
    }

    // Update the specific field in quotationdata
    updatedQuotationData[selectedQuotationId][index][name] = value;

    return updatedQuotationData;
  });
  console.log("input",quotationinputData);
  };


const handleQuotationChange = (name, value) => {
  setFormData2((prevData) => ({
    ...prevData,
    [name]: value,
  }));

  // Update quotationData with the current quotation's edited data
  setQuotationData((prevData) => ({
    ...prevData,
    [selectedQuotationId]: {
      ...prevData[selectedQuotationId],
      [name]: value,
    },
  }));
  console.log("Updated field:",quotations, name, "with value:", value,quotationinputData);
};

 const handleInputChange2_1 = (name, value) => {
    setFormData2((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    console.log("vendor type",name, value)
    };


  const handleInputChange3 = (name, value) => {
    setFormData3((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };


  const handleSubmit = (e) => {
    e.preventDefault();
    if (editMode) {
      handleUpdate();
    } else {
      handleCreate();
    }
  };

  // Toggle div visibility
  const toggleDiv1 = () => setIsDiv1Open(!isDiv1Open);
  const toggleDiv2 = () => setIsDiv2Open(!isDiv2Open);
  const toggleDiv3 = () => setIsDiv3Open(!isDiv3Open);
  const toggleDiv4 = () => setIsDiv4Open(!isDiv4Open);

  if (loading) return <LoaderComponent />;

  return (
    <div>
      <h2 className="pt-1 pb-1 text-center" style={{ color: "#4969ab", fontSize: '18px' }}>
        PURCHASE REQUIREMENT
      </h2>

<div style={{display: "flex"}}>
      <div className="prf-container">
           <span className="prf-label">PRF No:</span>
           <input
           type="text"
           value={prfno}
           readOnly
           className="prf-input"
           />
      </div>

      <div className="prf-container">
           <span className="prf-label">Reporting Manager:</span>
           <input
           type="text"
           value={manager}
           readOnly
           className="prf-input"
           />
      </div>
</div>

      {error && <div style={{ color: "red" }}>{error}</div>}

      {/* First collapsible section */}
      <div style = {{margin:"10px"}}>
        <h3 onClick={toggleDiv1} style={{ cursor: "pointer", color: "#4969ab" }}>
          Requirement Header {isDiv1Open ? '-' : '+'}
        </h3>
        {isDiv1Open && (
          <DynamicForm fields={fields} formData={formData} onInputChange={handleInputChange} onSubmit={handleSubmit} />
        )}
      </div>
{/* Second collapsible section */}
<div style = {{margin:"10px"}}>
  <h3 onClick={toggleDiv2} style={{ cursor: "pointer", color: "#4969ab" }}>
    Requirement Info {isDiv2Open ? '-' : '+'}
  </h3>
<div style={{marginLeft: "20px",marginRight: "20px",backgroundColor: 'white',borderRadius: '8px'}}>
  {isDiv2Open && (
    <div>
      {/* Render rows dynamically with input fields */}
      {section2Rows && section2Rows.length > 0 ? (
        section2Rows.map((row, index) => (
          <div
            key={index}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              margin: "20px",
              backgroundColor: 'white',
              borderRadius: '8px',
            }}
          >
            {/* Render each field in the row */}
            {fields1.map((field, fieldIndex) => (
              <div key={fieldIndex} className="form-group">
                <label className="form-label" style={{ marginLeft: "5px" }}>
                  {formatColumnName(field.columnName)}:
                </label>
                <div className="form-input">
                  <input
                    type="text"
                    name={field.columnName}
                    value={row[field.columnName] || ""}
                    onChange={(e) => handleInputChange1(field.columnName, e.target.value, index)}
                    style={{
                      flex: 1,
                      padding: '5px',
                      marginLeft: "5px",
                      border: '1px solid #ccc',
                      borderRadius: '4px',
                    }}
                  />
                </div>
              </div>
            ))}

            {/* Add delete icon for each row */}
            <Icon
              name="trash"
              style={{ cursor: "pointer", marginLeft: "10px", color: "red" }}
              onClick={() => deleteRowInSection2(index)}
            />

            {/* Add + icon only for the last row */}
            {index === section2Rows.length - 1 && (
              <Icon
                name="plus"
                style={{ cursor: "pointer", marginLeft: "10px", color: "green" }}
                onClick={addRowInSection2}
              />
            )}
          </div>
        ))
      ) : (
        <p>No rows available</p>
      )}
    </div>
  )}
</div>
</div>
      {/* Third collapsible section */}
      <div style = {{margin:"10px"}}>
        <h3 onClick={toggleDiv3} style={{ cursor: "pointer", color: "#4969ab" }}>
          Quotation Info {isDiv3Open ? '-' : '+'}
        </h3>
{isDiv3Open && (
  <div>
    {/* Tab-like navigation for quotations */}
    <div style={{ display: "flex", alignItems: "center", gap: "10px", flexWrap: "wrap" }}>
      {quotations.map((quotation, index) => (
        <button
          key={quotation.id}
          onClick={() => setSelectedQuotation(index)}
          style={{
            padding: "10px 20px",
            cursor: "pointer",
            border: "none",
            borderBottom: selectedQuotationId === index ? "2px solid blue" : "2px solid transparent",
            backgroundColor: selectedQuotationId === index ? "#f0f0f0" : "white",
            fontWeight: selectedQuotationId === index ? "bold" : "normal"
          }}
        >
          {quotation.label}
        </button>
      ))}
      <button onClick={addQuotation} style={{ padding: "10px 20px", marginLeft: "10px" }}> + </button>
    </div>

    {/* Render the selected quotation's form */}
    {quotations.map((quotation, index) => (
      selectedQuotationId === index && (
        <div key={`form-${quotation.id}`} style={{ marginTop: "20px" }}>
          <DynamicForm
            fields={fields2}
            formData={formData2}
            onInputChange={handleQuotationChange}
            onSubmit={handleSubmit}
          />

          {/* Section to render rows with dynamic add and delete functionality */}
          {section3Rows && section3Rows.length > 0 ? (
            section3Rows.map((row, rowIndex) => (
              <div
                key={rowIndex}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  margin: "20px",
                  backgroundColor: 'white',
                  borderRadius: '8px',
                  padding: '10px'
                }}
              >
                {/* Render each field in the row */}
                {fields1.map((field, fieldIndex) => (
                  <div key={fieldIndex} className="form-group">
                    <label className="form-label" style={{ marginLeft: "5px" }}>
                      {formatColumnName(field.columnName)}:
                    </label>
                    <div className="form-input">
                      <input
                        type="text"
                        name={field.columnName}
                        value={row[field.columnName] || ""}
                        onChange={(e) => handlequotatationInputChange3(field.columnName, e.target.value, rowIndex)}
                        style={{
                          flex: 1,
                          padding: '5px',
                          marginLeft: "5px",
                          border: '1px solid #ccc',
                          borderRadius: '4px',
                        }}
                      />
                    </div>
                  </div>
                ))}

                {/* Add delete icon for each row */}
                <Icon
                  name="trash"
                  style={{ cursor: "pointer", marginLeft: "10px", color: "red" }}
                  onClick={() => deleteRowInSection3(rowIndex)}
                />

                {/* Add + icon only for the last row */}
                {rowIndex === section3Rows.length - 1 && (
                  <Icon
                    name="plus"
                    style={{ cursor: "pointer", marginLeft: "10px", color: "green" }}
                    onClick={addRowInSection3}
                  />
                )}
              </div>
            ))
          ) : (
            <p>No rows available</p>
          )}
        </div>
      )
    ))}
  </div>
)}
   
      </div>
      {/* Fourth collapsible section */}
      <div style = {{margin:"10px"}}>
        <h3 onClick={toggleDiv4} style={{ cursor: "pointer", color: "#4969ab" }}>
          Quotation Process {isDiv4Open ? '-' : '+'}
        </h3>
        {isDiv4Open && (
          <div>
          <DynamicForm fields={fields3} formData={formData3} onInputChange={handleInputChange3} onSubmit={handleSubmit} />
          </div>
        )}
      </div>


      {/* Submit Button in a Separate Row */}
      <div className="submit-row">
        <button type="submit" className="submit-btn" onClick={handleSubmit}>Submit</button>
      </div>

    </div>


  );
}

export default PurchaseRequirement;
